import type { FaireProductEntity } from "../../entity_types/product";

export const p_vtb483agtr: FaireProductEntity = {
  token: "p_vtb483agtr",
  type: "product",
  name: "Field Day Case - 24 cans",
  brandToken: "b_f358njub53",
  brandName: "Comeback",
  imageUrl:
    "https://cdn.faire.com/fastly/e77df028280c1c2d48c00320527f996751282f8e879e1ec575ad74b4101cd3eb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/573ec1cd6edd9e7f0d175303d4a59e926de75c90d4990d619d13a676acd9516f.jpeg",
    "https://cdn.faire.com/fastly/85cf749cadd49bc0ae5647eda36ddb275da430a012fbc1c526808cf1b03c96e8.jpeg",
    "https://cdn.faire.com/fastly/a6992f7744338dbb21fab6dea02da58303a7b94fb4d9dea726b416ecc812bfcd.jpeg",
    "https://cdn.faire.com/fastly/d7b6195b055dc2560847717e51f0edd1769d89e0074b69f1ff7fb45196f8b1b7.jpeg",
  ],
  priceDollars: 2.75,
  description:
    "\nRemember your favorite juice pouch from childhood? Well, imagine it now with coffee and bubbles for a fun new way to enjoy the flavors you already know and love.\n\nAt Comeback, we source high-quality ingredients to combine with our in-house roasted and flash-chilled coffee. Shaking up the typical flavors often combined with coffee, we rejoin coffee with its first home, fruit.\n",
  tags: [],
  msrpDollars: 5.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:09.776Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
